import { create } from 'zustand'
import type { ActionType, Direction, Coord } from '@fleetduel/shared'

export interface AudioSettings {
  sfxMuted: boolean
  uiMuted: boolean
  ambientMuted: boolean
}

function loadAudioSettings(): AudioSettings {
  try {
    const raw = localStorage.getItem('fleetduel-audio')
    if (raw) return JSON.parse(raw)
  } catch {}
  return { sfxMuted: false, uiMuted: false, ambientMuted: false }
}

export interface UIStore {
  selectedAction: ActionType
  torpedoDirection: Direction
  sonarPreview: Coord | null
  lastSonarCount: number | null
  showWarning: boolean
  warningMessage: string
  hoveredCell: string | null
  audioSettings: AudioSettings

  setSelectedAction: (action: ActionType) => void
  setTorpedoDirection: (dir: Direction) => void
  setSonarPreview: (coord: Coord | null) => void
  setLastSonarCount: (count: number | null) => void
  showWarningMessage: (msg: string) => void
  hideWarning: () => void
  setHoveredCell: (key: string | null) => void
  setAudioMute: (category: keyof AudioSettings, muted: boolean) => void
}

export const useUIStore = create<UIStore>((set) => ({
  selectedAction: 'strike',
  torpedoDirection: 'horizontal',
  sonarPreview: null,
  lastSonarCount: null,
  showWarning: false,
  warningMessage: '',
  hoveredCell: null,
  audioSettings: loadAudioSettings(),

  setSelectedAction: (action) => set({ selectedAction: action }),
  setTorpedoDirection: (dir) => set({ torpedoDirection: dir }),
  setSonarPreview: (coord) => set({ sonarPreview: coord }),
  setLastSonarCount: (count) => set({ lastSonarCount: count }),
  showWarningMessage: (msg) => set({ showWarning: true, warningMessage: msg }),
  hideWarning: () => set({ showWarning: false, warningMessage: '' }),
  setHoveredCell: (key) => set({ hoveredCell: key }),
  setAudioMute: (category, muted) => set(s => {
    const next = { ...s.audioSettings, [category]: muted }
    try { localStorage.setItem('fleetduel-audio', JSON.stringify(next)) } catch {}
    return { audioSettings: next }
  }),
}))
